(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/select-digital-tickets.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/select-digital-tickets.js');
"use strict";

const TicketsTable = svs.ticket_partner.sharedComponents.ticketsTable.TicketsTable;
const UPDATE_ARTICLES = svs.ticket_partner.digitalTickets.actions.UPDATE_ARTICLES;
const _svs$ticket_partner$d = svs.ticket_partner.digitalTickets.constants.FORMS,
  MINIMUM_AMOUNT = _svs$ticket_partner$d.MINIMUM_AMOUNT,
  MINIMUM_AMOUNT_LOGGED_IN = _svs$ticket_partner$d.MINIMUM_AMOUNT_LOGGED_IN,
  MINIMUM_AMOUNT_ERROR_MESSAGE = _svs$ticket_partner$d.MINIMUM_AMOUNT_ERROR_MESSAGE;
const INFO = svs.ticket_partner.constants.copy.TICKETS_TABLE.INFO;
const _React = React,
  useContext = _React.useContext;
const SelectDigitalTickets = () => {
  const _useContext = useContext(svs.ticket_partner.UserContext),
    isLoggedIn = _useContext.isLoggedIn;
  const _useContext2 = useContext(svs.ticket_partner.DigitalTicketsContext),
    state = _useContext2.state,
    dispatch = _useContext2.dispatch;
  const handleOnChange = (e, article) => {
    dispatch({
      type: UPDATE_ARTICLES,
      payload: {
        count: e.target.value || 0,
        articleId: article.ticketId,
        price: article.price,
        name: article.ticketTitle
      }
    });
  };
  return React.createElement("div", {
    className: "margin-bottom-2"
  }, React.createElement(TicketsTable, {
    articles: state.articles,
    cmsArticles: svs.ticket_partner.data.articles.ticketsDigital,
    handleOnChange: handleOnChange,
    infoMessage: !isLoggedIn && INFO,
    isEditable: true,
    minimumAmount: isLoggedIn ? MINIMUM_AMOUNT_LOGGED_IN : MINIMUM_AMOUNT,
    minimumAmountErrorMessage: MINIMUM_AMOUNT_ERROR_MESSAGE
  }));
};
svs.ticket_partner.digitalTickets.digitalTicketsForm.selectDigitalTickets.SelectDigitalTickets = SelectDigitalTickets;

 })(window);